import { ConfirmCancelComponent } from './../confirm-cancel/confirm-cancel.component';
import { BreadCrumbService } from './../../../../lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { BreadCrumbModel } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { Component, OnChanges, OnInit, ElementRef, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel, FilterService } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { CancelParticipationService } from './../shared/providers/cancel-participation.service';
import { FanModel } from './../shared/models/cancel-participation.model';
import { Router, ActivatedRoute } from '@angular/router';
import { PageLoaderService } from './../../../../lib/ng2-sapmp/src/ui-components/page-loader/page-loader.service';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { CANCELFANDATA } from 'config';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config';

@Component({
  selector: 'app-select-fan',
  templateUrl: './select-fan.component.html',
  styleUrls: ['./select-fan.component.scss'],
  providers: [FilterService, CancelParticipationService, AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})

export class SelectFanComponent implements OnInit {
  formName: string;
  companyId: number;
  FANList: Array<FanModel>;
  //displayList: Array<FanModel>;
  SelectedFANList: Array<FanModel>;
  list: Array<FanModel>;
  gridOptions: GridOptionsModel;
  columnSelection: string;
  callingBackUrl: string;
  selectedFan: any;
  showError: boolean;
  pageContent: any;
  fanid: any;
  unclaim: boolean;
  unclaimCheck: boolean;
  prodcode: string;
  mdmDets: any;
  ibmflag: boolean = false;
  mdmDetails: any;
  fanInfoList: any;
  accountemmid: any;
  accountId: any;
  prodDets: any;
  abmflag: boolean=false;


  constructor(protected cancelParticipationService: CancelParticipationService, private router: Router,
    private breadCrumbService: BreadCrumbService, private utilityService: UtilityService, private pageLoaderService: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService, private route: ActivatedRoute) {
    this.companyId = 2;  // Company ID four for Revised Setup (All fans)
    this.FANList = [];
    //this.displayList = [];
    this.SelectedFANList = [];
    this.list = [];
    this.columnSelection = 'multicol';
    //this.pageLoaderService.setPageLoaderStatus(false);
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.formName = 'Cancel Participation';
    this.pageLoaderService.setPageLoaderStatus(false);
    this.mdmDets = JSON.parse(sessionStorage.getItem('mdmDetails'));
    const totalFan = this.cancelParticipationService.getCancelledFanData();
    this.FANList = [];
    this.cancelParticipationService.getFanStatusSummary(this.companyId).subscribe(respobj =>{
      if(respobj !== null){
        let faninfolist = respobj.fanInfoList;
        sessionStorage.setItem('fanInfoList', JSON.stringify(faninfolist));

      }
    },
    error => {
     this.showError = true;
    });

    if (this.mdmDets.productCode === 'ADDPMDM') {
      sessionStorage.setItem('ibmflag', 'true');
      this.ibmflag = true;
      this.fanid = sessionStorage.getItem('fanID');
      if (totalFan) {
        this.FANList = totalFan.allFanList;
        this.SelectedFANList = this.FANList.filter(item => item.selected === true);
        this.initGrid();
        this.getContentmdm();
        this.pageLoaderService.setPageLoaderStatus(true);
      } else {
        this.getFANList();
        this.pageLoaderService.setPageLoaderStatus(true);
      }
    }
    else if (this.mdmDets.productCode === 'ADDPZTE' || this.mdmDets.productCode === 'DMPAABM') {
      this.pageLoaderService.setPageLoaderStatus(false);
      this.unclaimCheck = false;
      if (JSON.parse(sessionStorage.getItem('unclaimFlag')) === false) {
        this.unclaim = true;
      } else {
        this.unclaim = sessionStorage.getItem('unclaimFlag') ? JSON.parse(sessionStorage.getItem('unclaimFlag')) : false;
      }
      this.prodcode = sessionStorage.getItem('prodcode');
      this.fanid = sessionStorage.getItem('fanID');
      if (totalFan) {
        this.FANList = totalFan.allFanList;
        this.SelectedFANList = this.FANList.filter(item => item.selected === true);
        this.initGrid();
        this.getContent();
        this.pageLoaderService.setPageLoaderStatus(true);
      } else {
        this.getFANList();
        this.pageLoaderService.setPageLoaderStatus(true);
      }
    }
    //this.breadCrumbService.removeLastBreadCrumb();
    const callingPageUrl = this.breadCrumbService.getLastUrlFromBreadCrumb().routerLink;
    this.callingBackUrl = callingPageUrl.currentUrl;
    //sessionStorage.setItem('cancelCallingBackUrl', JSON.stringify({ callingPageUrl }));
    this.cancelParticipationService.createPageLoadProperties('SELECTFAN', 'selectfan');
    //this.pageLoaderService.setPageLoaderStatus(true);

    // Content Rendering
     
  }

  getContent() {
    // this.cancelParticipationService.pageContent(this.utilityService.getEnvConfig().contentUrl.cancelParticipation.cancel).
    //   subscribe(respobj => {
        this.pageContent = this.route.snapshot.data.pageData.cancelParticipationselectfan;
        this.pageContent.selectedFans = this.pageContent.selectedFanTmp.replace('<selectedFanCount>', this.SelectedFANList.length);
        this.pageContent.selectedFans = this.pageContent.selectedFans.replace('<account/accounts>',
        this.SelectedFANList.length === 0 ? 'accounts.' : this.SelectedFANList.length > 1 ? 'accounts.' : 'account.');
        let fanCount = 0;
        fanCount = JSON.parse(sessionStorage.getItem('fanLength'));
        this.pageContent.fanCount = this.pageContent.fanCount.replace('<XXX>', fanCount);
        this.pageContent.fanCount = this.pageContent.fanCount.replace('<account/accounts>',
        fanCount === 0 ? 'accounts.' : fanCount > 1 ? 'accounts.' : 'account.');
      // }, error => {
      //   console.log(error);
      // });
  }

  getContentmdm() {
    this.cancelParticipationService.pageContent(this.utilityService.getEnvConfig().contentUrl.cancelParticipation.cancel).
      subscribe(respobj => {
        this.pageContent = respobj;
        this.pageContent.selectedFans = this.pageContent.selectedFanTmp.replace('<selectedFanCount>', this.SelectedFANList.length);
        this.pageContent.selectedFans = this.pageContent.selectedFans.replace('<account/accounts>',
        this.SelectedFANList.length === 0 ? 'accounts.' : this.SelectedFANList.length > 1 ? 'accounts.' : 'account.');
        let fanCount = 0;
        fanCount = JSON.parse(sessionStorage.getItem('fanLength'));
        this.pageContent.fanCount = this.pageContent.fanCount.replace('<XXX>', fanCount);
        this.pageContent.fanCount = this.pageContent.fanCount.replace('<account/accounts>',
        fanCount === 0 ? 'accounts.' : fanCount > 1 ? 'accounts.' : 'account.');
      }, error => {
        console.log(error);
      });
  }

  backToCallingPage() {
    sessionStorage.removeItem('fanLength');
    sessionStorage.removeItem('CancelParticipationData');
    sessionStorage.removeItem('unclaimFlag');
    const previousUrl = sessionStorage.getItem('previousRoute');
      if(previousUrl === '/cancelParticipation/selectfan') {
        this.router.navigate(['cancelParticipation/selectfan']);
        }
        else {
        this.router.navigate(['cancelParticipation/removeaccount']);
        }
  }
  toggleTooltip(event) {
    if (event.type !== 'click') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipEnter(event) {
    if (event.type !== 'mouseenter') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipLeave(event) {
    if (event.type !== 'mouseleave') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  backToCallingPagemdm() {
    sessionStorage.removeItem('fanLength');
    sessionStorage.removeItem('CancelParticipationData');
    //this.router.navigate([this.breadCrumbService.getLastUrlFromBreadCrumb().routerLink]);
    const previousUrl = sessionStorage.getItem('cancelCallingBackUrl');
    this.router.navigate([previousUrl]);
  }

  /* Getting all fan list*/
  getFANList() {
    this.cancelParticipationService.getFANList(this.companyId).
      subscribe(respobj => {
        this.FANList = respobj.revisedFanList.concat(respobj.newSetupFanList.map(item => {
          item['accountStatus'] = 'Signed - Up';
          return item;
        }));
        if(this.unclaim) {
          let list = respobj.revisedFanList.filter(item => item.accountStatus === 'ACTIVE');
          list = list.concat(respobj.revisedFanList.filter(item => item.accountStatus === 'PROCESSING' && item.productCode != 'DMPAABM'))
          if (this.prodcode === 'Apple Business Manager') {
          this.FANList = list.filter(item => item.productCode === 'DMPAABM');
          this.abmflag = true;
          } else if (this.prodcode === 'Samsung Knox Mobile') {
          this.FANList = list.filter(item => item.productCode === 'DMPSKME');
          } else {
          this.FANList = list.filter(item => item.productCode === 'DMPGZTP');
          }
          }
        const getPreviousRoute = sessionStorage.getItem('previousRoute');
        const split = getPreviousRoute.split('/');
        if (split[2] === 'deviceInventory') {
          this.selectedFan = sessionStorage.getItem('selectedFAN');
          this.FANList.forEach(item => {
            if (item.fanId === this.selectedFan) {
              item.selected = true;
            }
            this.SelectedFANList = this.FANList.filter(item => item.fanId === this.selectedFan);
          });
         // this.FANList = this.FANList.filter(item => item.fanId === this.selectedFan);
        }

        this.initGrid();
        this.getContent();
        this.pageLoaderService.setPageLoaderStatus(true);
      },
      error => {
        this.showError = true;
        this.pageLoaderService.setPageLoaderStatus(true);

      });
  }

  initGrid() {
    const options = new GridOptionsModel();
    // options.enableFiltering = false;
    // if (this.FANList.length > 20) {
    //   options.enableFiltering = false;
    // }
    options.enableSorting = false;
    options.multiSelect = true;
    options.enableBackLink = true;
    options.backLinkText = 'View all accounts';
    // options.emptyMessage = 'We didn’t find any accounts that match your search.' +
    // 'Did you enter the full account number? Check the number and try your search again.';
    // options.searchType = 'number';

    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: false,
      totalRecords: this.list.length
    };

    options.Paginations = pagination;
    if (this.unclaim) {
      options.gridData = this.FANList;
      this.list = this.FANList;
      options.enableFiltering = false;
    if (this.FANList.length > 20) {
      options.enableFiltering = false;
    }
    options.callbacks = {statusCellTemplate: this.statusCellTemplateRemove};
    }
    else {
      options.gridData = this.FANList;
      this.list = this.FANList;
      options.enableFiltering = false;
    if (this.FANList.length > 20) {
      options.enableFiltering = true;
    }
    options.callbacks = {statusCellTemplate: this.statusCellTemplate};
    }

    //options.searchPlaceHolder = 'Enter full foundation account number';
    //options.ariaLabel = 'Enter full foundation account number';
    //options.callbacks = {statusCellTemplate: this.statusCellTemplate};

    options.columnDefinitions = CANCELFANDATA.fanList[this.columnSelection].columnDefinitions;
    options.disableRow = CANCELFANDATA.fanList[this.columnSelection].rowDisable;
    options.disableRowCondition = CANCELFANDATA.fanList[this.columnSelection].rowDisableCondition;
    this.gridOptions = options;
  }


 statusCellTemplate(element, row, field, currentElem, type) {
    if (type === 'template') {
      return `<div>${CANCELFANDATA.statusLabel[row.accountStatus] === undefined ? 'Ready for setup' : CANCELFANDATA.statusLabel[row.accountStatus]}</div>`;
    }
  }

  statusCellTemplateRemove(element, row, field, currentElem, type) {
    if (type === 'template') {
      if (row.profileName !== undefined && row.profileName !== null) {
        row.profileName = '';
      }
      //return `<div>${CANCELFANDATA.statusLabel[row.accountStatus] === 'ACTIVE' ? 'Active' : 'Active'}</div>`;
      this.mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
      this.prodDets = JSON.parse(sessionStorage.getItem('manage-product'));
      this.fanInfoList = JSON.parse(sessionStorage.getItem('fanInfoList'));
      //console.log(this.fanInfoList);
      if(this.prodDets.emmProductCode === 'DMPGZTP'){
        this.accountemmid = this.mdmDetails.googleEmmAccountId;
        this.accountId ='ZTP ID: ' + this.accountemmid;
      }
      else if(this.prodDets.emmProductCode === 'DMPSKME'){
        this.accountemmid = this.mdmDetails.samsungEmmAccountId;
        this.accountId ='KME ID: ' + this.accountemmid;
      }
      else if(this.prodDets.emmProductCode === 'DMPAABM'){
        this.fanInfoList.forEach(element => {
        if(row.fanId === element.fan && row.productCode === element.emmProductCode){
          this.accountemmid = element.emmAccountId;
          this.accountId ='Apple Org ID: ' + this.accountemmid;
        }
        });
      }

      return `<div>${CANCELFANDATA.statusLabel[row.accountStatus] === 'ACTIVE' ? this.accountId : this.accountId }</div>`;
      //return `<div>${CANCELFANDATA.statusLabel[row.accountStatus] === 'ACTIVE' ? 'KMEID:' : this.SelectedFANList.length }</div>`;
    }
  }

  /* Fan selection watched here from Grid*/
  onRowClick(action) {
    this.SelectedFANList = this.FANList.filter(item => item.selected === true);
    this.pageContent.selectedFans = this.pageContent.selectedFanTmp.replace('<selectedFanCount>', this.SelectedFANList.length);
    this.pageContent.selectedFans = this.pageContent.selectedFans.replace('<account/accounts>',
        this.SelectedFANList.length === 0 ? 'accounts.' : this.SelectedFANList.length > 1 ? 'accounts.' : 'account.');
  }

  continueToNext() {  
    if (this.unclaimCheck === false) {
    sessionStorage.setItem('unclaimFlag', 'false');
    // use multi col config
    this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS', 'formSubmit',
    'BC_Device_Cancel_Select_FAN_Submit', 'success', 'Success_Admit', 'Remove accounts', 'Body',
    '/businessconsole/cancelParticipation/review');
    this.cancelParticipationService.saveCancelledFAN(this.FANList, this.SelectedFANList, this.columnSelection = 'singlecol');
    // Adobe Analytics Success Type Starts
    this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS',
    'formResponse', 'BC_Device_Cancel_Select_FAN_Submit', 'success', 'Success_Admit', 'Remove accounts',
    'Body', '/businessconsole/cancelParticipation/review');
    // const data = { code: 'cancel_select_fan', errorType: 'SUCCESS_TYPE', successFlag: 1, msg: '' };
    // this.adobeAnalyticsService.trackEventProperties(data);
    // Ends
    sessionStorage.setItem('selectedFanList', JSON.stringify(this.SelectedFANList));
    this.router.navigate(['cancelParticipation/review']);
    }
    else {
    // use multi col config
    this.adobeAnalyticsService.createAdobeEventProperties('UNCLAIMDEVICES', 'SUCCESS', 'formSubmit',
    'BC_Device_Cancel_Select_FAN_Submit', 'success', 'Success_Admit', 'Unclaim devices', 'Body',
    '/businessconsole/cancelParticipation/unclaimdevices');
    this.cancelParticipationService.saveUnclaimDevicesFan(this.FANList, this.SelectedFANList, this.columnSelection = 'multicol');
    // Adobe Analytics Success Type Starts
    this.adobeAnalyticsService.createAdobeEventProperties('UNCLAIMDEVICES', 'SUCCESS',
    'formResponse', 'BC_Device_Cancel_Select_FAN_Submit', 'success', 'Success_Admit', 'Unclaim devices',
    'Body', '/businessconsole/cancelParticipation/unclaimdevices');
    // Ends
    sessionStorage.setItem('selectedFanList', JSON.stringify(this.SelectedFANList));
      this.router.navigate(['cancelParticipation/unclaimdevices'])
    }
  }

  continueToNextmdm() {  // use multi col config
    this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS', 'formSubmit',
    'BC_Device_Cancel_Select_FAN_Submit', 'success', 'Success_Admit', 'Remove accounts', 'Body',
    '/businessconsole/cancelParticipation/review');
    this.cancelParticipationService.saveCancelledFAN(this.FANList, this.SelectedFANList, this.columnSelection = 'singlecol');
    // Adobe Analytics Success Type Starts
    this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS',
    'formResponse', 'BC_Device_Cancel_Select_FAN_Submit', 'success', 'Success_Admit', 'Remove accounts',
    'Body', '/businessconsole/cancelParticipation/review');
    // const data = { code: 'cancel_select_fan', errorType: 'SUCCESS_TYPE', successFlag: 1, msg: '' };
    // this.adobeAnalyticsService.trackEventProperties(data);
    // Ends
    sessionStorage.setItem('selectedFanList', JSON.stringify(this.SelectedFANList));
    this.router.navigate(['cancelParticipation/review']);
  }
  
}

